export default __webpack_public_path__ + "static/media/logo-treviso.ccd18590.png";